export default "__VITE_ASSET__SyG$02Ev__"